import React from 'react';
import {
  IonContent,
  IonPage,
  IonIcon,
} from '@ionic/react';
import { connect } from '../data/connect';
import { chevronBackOutline } from 'ionicons/icons';
import './MapIframePage.css';

interface StateProps {
  darkMode: boolean;
}

interface MapIframePageProps extends StateProps {}

const MapIframePage: React.FC<MapIframePageProps> = ({ darkMode }) => {
  return (
    <IonPage id="map-iframe-page">
      <IonContent fullscreen={true} className="map-content">
        <div className="map-container">
          {/* Botón de regreso */}
          <div className="back-button-container">
            <button className="back-button" onClick={() => window.history.back()}>
              <IonIcon icon={chevronBackOutline} />
            </button>
          </div>

          {/* Mapa principal */}
          <div className="map-iframe-wrapper">
            <iframe
              src="https://centroamericanoavicultura.com/mapa"
              title="Mapa del evento"
              className="map-iframe"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default connect<{}, StateProps, {}>({
  mapStateToProps: (state) => ({
    darkMode: state.user.darkMode,
  }),
  component: MapIframePage
});
